import { render } from "./NoticePayments.vue?vue&type=template&id=ad24e74c"
const script = {}

import "./NoticePayments.vue?vue&type=style&index=0&id=ad24e74c&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__